<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.source_onboarding"
        :items="sourceOnboardingList"
        label="Source Onboarding"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>

    <td
      v-if="menuType === 'subMerchantInputer'"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.merchant_name"
        type="text"
        label="Nama Merchant"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.mid"
        type="text"
        label="MID"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.nmid"
        type="text"
        label="NMID"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.mpan"
        type="text"
        label="MPAN"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.address"
        type="text"
        label="Alamat Lengkap"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.merchant_criteria"
        :items="listMerchantCriteria"
        label="Kriteria Merchant"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.qr_type"
        :items="listQrType"
        label="Jenis QR"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.sn"
        type="text"
        label="Serial Number"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormatted"
            label="Tanggal Active"
            v-bind="attrs"
            @blur="searchData.created_at = parseDate(dateFormatted)"
            v-on="on"
            hide-details="true"
            dense
          />
        </template>
        <v-date-picker
          v-model="searchData.created_at"
          no-title
          scrollable
          @input="dateMenu = false"
        >
          <v-spacer />
          <v-btn text color="primary" @click="dateMenu = false"> Cancel </v-btn>
        </v-date-picker>
      </v-menu>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-menu
        ref="dateMenuInactive"
        v-model="dateMenuInactive"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormattedInactive"
            label="Tanggal Inactive"
            v-bind="attrs"
            @blur="searchData.deactivated_at = parseDate(dateFormattedInactive)"
            v-on="on"
            hide-details="true"
            dense
          />
        </template>
        <v-date-picker
          v-model="searchData.deactivated_at"
          no-title
          scrollable
          @input="dateMenuInactive = false"
        >
          <v-spacer />
          <v-btn text color="primary" @click="dateMenuInactive = false">
            Cancel
          </v-btn>
        </v-date-picker>
      </v-menu>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.status"
        :items="listAccountStatus"
        label="Status"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataAllQrType,
  dataSettlementTypeItems,
  dataSourceOnboardingList,
} from '../../store/params';
import { formatDate, parseDate } from '../../lib/helpers';

export default {
  props: ['search'],
  data: () => ({
    dateFormatted: '',
    dateMenu: false,
    dateFormattedInactive: '',
    dateMenuInactive: false,
    listMerchantCriteria: dataListMerchantCriteria,
    listAccountStatus: dataListAccountStatus,
    listQrType: dataAllQrType,
    settlementTypeItems: dataSettlementTypeItems,
    sourceOnboardingList: dataSourceOnboardingList,
  }),

  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    menuType() {
      let type;
      switch (this.$route?.name) {
        case 'InputerMerchant':
          type = 'merchantInputer';
          break;
        case 'InputerAllSubMerchant':
        case 'InputerSubMerchant':
          type = 'subMerchantInputer';
          break;
        default:
          type = 'nonMerchant';
          break;
      }

      return type;
    },
  },
  watch: {
    'searchData.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.searchData.created_at);
        this.getData();
      },
    },

    'searchData.deactivated_at': {
      handler() {
        this.dateFormattedInactive = this.formatDate(
          this.searchData.deactivated_at
        );
        this.getData();
      },
    },
  },
  methods: {
    getData() {
      this.$emit('getDataParent');
    },
    formatDate,
    parseDate,
  },
};
</script>
